import bg_home from 'assets/images/bg_home.png';
import HeaderMenu from 'components/Header/HeaderMenu';
import { SITE } from 'config/config';
import { twMerge } from 'tailwind-merge';
import MatchResult from './MatchResult';

const PrizeStructure = () => {
  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src={bg_home}
        alt="Background"
        className="h-full w-full fixed right-0 bottom-0 object-cover"
      />
      <div className="hidden xl:block">
        <div className="fixed left-0 top-4">
          <img
            src="assets/images/match/terry1.png"
            alt="Background"
            className="w-80 h-auto object-contain"
          />
        </div>
        <div className="fixed right-0 bottom-0">
          <img
            src="assets/images/match/terry2.png"
            alt="Background"
            className="w-60 h-auto object-contain"
          />
        </div>
      </div>
      <div className="relative z-10 pb-5">
        <HeaderMenu />
        <div className="container relative px-2 z-10">
          <MatchResult />
        </div>
      </div>{' '}
    </div>
  );
};

export default PrizeStructure;
